/**
 * List of Twitter supported languages
 *
 * Are you going to edit this file? Then make sure your editor will save it as utf-8
 * otherwise the non-latin characters will get distorted.
 */
var langs = [
    {
        "value": "am",
        "label": "Amharic (አማርኛ)"
    },
    {
        "value": "ar",
        "label": "Arabic (العربية)"
    },
    {
        "value": "hy",
        "label": "Armenian (հայերեն)"
    },
    {
        "value": "bn",
        "label": "Bengali (বাংলা)"
    },
    {
        "value": "bg",
        "label": "Bulgarian (български)"
    },
    {
        "value": "my",
        "label": "Burmese (ဗမာ)"
    },
    {
        "value": "ckb",
        "label": "Central Kurdish (کوردیی ناوەندی)"
    },
    {
        "value": "zh",
        "label": "Chinese (中文)"
    },
    {
        "value": "da",
        "label": "Danish (dansk)"
    },
    {
        "value": "dv",
        "label": "Divehi (Divehi)"
    },
    {
        "value": "nl",
        "label": "Dutch (Nederlands)"
    },
    {
        "value": "en",
        "label": "English (English)"
    },
    {
        "value": "et",
        "label": "Estonian (eesti)"
    },
    {
        "value": "fi",
        "label": "Finnish (suomi)"
    },
    {
        "value": "fr",
        "label": "French (français)"
    },
    {
        "value": "ka",
        "label": "Georgian (ქართული)"
    },
    {
        "value": "de",
        "label": "German (Deutsch)"
    },
    {
        "value": "el",
        "label": "Greek (Ελληνικά)"
    },
    {
        "value": "gu",
        "label": "Gujarati (ગુજરાતી)"
    },
    {
        "value": "ht",
        "label": "Haitian Creole (Haitian Creole)"
    },
    {
        "value": "he",
        "label": "Hebrew (עברית)"
    },
    {
        "value": "hi",
        "label": "Hindi (हिन्दी)"
    },
    {
        "value": "hu",
        "label": "Hungarian (magyar)"
    },
    {
        "value": "is",
        "label": "Icelandic (íslenska)"
    },
    {
        "value": "id",
        "label": "Indonesian (Indonesia)"
    },
    {
        "value": "it",
        "label": "Italian (italiano)"
    },
    {
        "value": "ja",
        "label": "Japanese (日本語)"
    },
    {
        "value": "kn",
        "label": "Kannada (ಕನ್ನಡ)"
    },
    {
        "value": "km",
        "label": "Khmer (ខ្មែរ)"
    },
    {
        "value": "ko",
        "label": "Korean (한국어)"
    },
    {
        "value": "lo",
        "label": "Lao (ລາວ)"
    },
    {
        "value": "lv",
        "label": "Latvian (latviešu)"
    },
    {
        "value": "lt",
        "label": "Lithuanian (lietuvių)"
    },
    {
        "value": "ml",
        "label": "Malayalam (മലയാളം)"
    },
    {
        "value": "mr",
        "label": "Marathi (मराठी)"
    },
    {
        "value": "ne",
        "label": "Nepali (नेपाली)"
    },
    {
        "value": "no",
        "label": "Norwegian (norsk)"
    },
    {
        "value": "or",
        "label": "Oriya (ଓଡ଼ିଆ)"
    },
    {
        "value": "ps",
        "label": "Pashto (پښتو)"
    },
    {
        "value": "fa",
        "label": "Persian (فارسی)"
    },
    {
        "value": "pl",
        "label": "Polish (polski)"
    },
    {
        "value": "pt",
        "label": "Portuguese (português)"
    },
    {
        "value": "pa",
        "label": "Punjabi (ਪੰਜਾਬੀ)"
    },
    {
        "value": "ro",
        "label": "Romanian (română)"
    },
    {
        "value": "ru",
        "label": "Russian (русский)"
    },
    {
        "value": "sr",
        "label": "Serbian (српски)"
    },
    {
        "value": "sd",
        "label": "Sindhi (سنڌي)"
    },
    {
        "value": "si",
        "label": "Sinhala (සිංහල)"
    },
    {
        "value": "sl",
        "label": "Slovenian (slovenščina)"
    },
    {
        "value": "es",
        "label": "Spanish (español)"
    },
    {
        "value": "sv",
        "label": "Swedish (svenska)"
    },
    {
        "value": "tl",
        "label": "Tagalog (Tagalog)"
    },
    {
        "value": "ta",
        "label": "Tamil (தமிழ்)"
    },
    {
        "value": "te",
        "label": "Telugu (తెలుగు)"
    },
    {
        "value": "th",
        "label": "Thai (ไทย)"
    },
    {
        "value": "bo",
        "label": "Tibetan (བོད་སྐད་)"
    },
    {
        "value": "tr",
        "label": "Turkish (Türkçe)"
    },
    {
        "value": "ur",
        "label": "Urdu (اردو)"
    },
    {
        "value": "ug",
        "label": "Uyghur (ئۇيغۇرچە)"
    },
    {
        "value": "vi",
        "label": "Vietnamese (Tiếng Việt)"
    }
];

export default langs;
